import { toast } from "sonner";
import { PageHeader, DataTable, GhostButton } from "@/components/admin/ui";
import { useFetch } from "@/hooks/useFetch";
import { api, errMsg, formatDateTime } from "@/lib/api";
import { Pill, CONSENT_STATUS } from "@/lib/status";

export default function Consents() {
  const { data, loading, reload } = useFetch("/admin/consents");
  const verify = async (id) => {
    try { await api.post(`/admin/consents/${id}/verify`); toast.success("Consent marked as verified"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="consents-page">
      <PageHeader eyebrow="Compliance" title="Parental consents" description="Every consent event with the statement version, method and verification status. In-app e-signatures are verified automatically by the parent's own payment." />
      <DataTable testId="consents-table" loading={loading} rows={data} columns={[
        { key: "student_name", label: "Student", render: (r) => <span className="font-semibold">{r.student_name}</span> },
        { key: "parent_email", label: "Parent" },
        { key: "version_number", label: "Version", render: (r) => `v${r.version_number}` },
        { key: "method", label: "Method", render: (r) => (r.method === "offline_signed_form" ? `Signed form ${r.form_reference || ""}` : `E-sign "${r.signature_name}"`) },
        { key: "verification_status", label: "Verification", render: (r) => <Pill map={CONSENT_STATUS} value={r.verification_status} /> },
        { key: "revoked", label: "Current", render: (r) => (r.revoked ? "Superseded" : "Yes") },
        { key: "created_at", label: "Recorded", render: (r) => formatDateTime(r.created_at) },
        { key: "a", label: "", render: (r) => !r.revoked && r.method === "in_app_esign" && r.verification_status !== "verified_admin" && <GhostButton onClick={() => verify(r.id)} data-testid={`verify-consent-${r.id}`}>Verify manually</GhostButton> },
      ]} />
    </div>
  );
}
